import { useEffect, useState } from "react";
import { useAuth } from "../auth/auth-context";
import { type AiBudgetState, fetchAiBudgetState } from "./ai-budget";

// Lecture unique au montage (pas de polling — la garde budgétaire tourne une
// fois par jour côté cron, pas besoin de temps réel ici, discipline egress).
// `null` = chargement OU fail-open (erreur de lecture) : dans les deux cas,
// aucune bannière n'est affichée par défaut (cf. BudgetAlertBanner /
// BudgetSuspendedBanner) — cohérent avec `isLlmSuspended` côté edge, qui ne
// bloque jamais sur une erreur.
export function useAiBudgetState(): AiBudgetState | null {
  const { client } = useAuth();
  const [state, setState] = useState<AiBudgetState | null>(null);

  useEffect(() => {
    let alive = true;
    fetchAiBudgetState(client).then(
      (r) => {
        if (!alive) return;
        if (r.ok) setState(r.data);
      },
      // Fail-open : un client mal formé / une exception inattendue ne doit
      // jamais remonter comme un rejet non géré — reste `null` (pas de bannière).
      () => {},
    );
    return () => {
      alive = false;
    };
  }, [client]);

  return state;
}
